
import './modules/register-service-worker';
import { branchBar } from '@crasman/branch-bar';
import heroInit from './modules/veho/hero';
import carouselInit from './modules/veho/carousel';
import mobileNavInit from './modules/veho/mobile-navigation';
import dropdownInit from './modules/veho/dropdown';
import youtubeInit from './modules/veho/youtube';

branchBar.init();// See https://www.npmjs.com/package/@crasman/branch-bar for settings

if (document.querySelector('.js-hero')) {
  heroInit();
}

if (document.querySelector('.js-carousel')) {
  carouselInit();
}

if (document.querySelector('.js-mobile-nav-opener')) {
  mobileNavInit();
}

if (document.querySelector('.js-dropdown')) {
  dropdownInit();
}

if(document.getElementsByTagName('iframe')) {
  youtubeInit();
}


const quickSiteSearchContainer = document.getElementById('nav-site-search');
if (quickSiteSearchContainer) {
  import(
    /* webpackChunkName: 'quickSiteSearch' */
    './modules/quick-site-search' as any
  ).then(({default: QuickSiteSearch}) => (
    new QuickSiteSearch(quickSiteSearchContainer)
  ));
}
